import BooleanButtons from "../../../components/shared/BooleanButtons";
import { LIST_VIEW } from "../../../constants";
import styled from 'styled-components';

const MainComponentStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 8px;
`;

const BookingViewChanger = ({ setTempRowData, myBookingsView, view, setView, isEquipmentView, setIsEquipmentView, setListGroupByView, listGroupByView, isToggle = false }) => {
  const handleView = (view) => {
    setView(view);
  };

  const handleGroupByView = (groupByType) => {
    if (setTempRowData) {
      setTempRowData([]);
    }
    setListGroupByView && setListGroupByView(groupByType);
    setView(LIST_VIEW);
    setIsEquipmentView && setIsEquipmentView(groupByType === 'NONE');
  };

  return (
    <MainComponentStyled >
      <BooleanButtons
        variant="bookingViews"
        value={view}
        listGroupByView={listGroupByView}
        onGroupByChange={handleGroupByView}
        onChange={handleView}
        color="primary"
        myBookingsView={myBookingsView}
      />
    </MainComponentStyled>
  );
};
export default BookingViewChanger;
